module.exports = __webpack_public_path__ + "img/requests.8f357104.svg";